// extracted by mini-css-extract-plugin
export default {"flex_container":"CafePageSite_flex_container__k1zdz","text":"CafePageSite_text__+q284","description":"CafePageSite_description__iwNXV","docTitle":"CafePageSite_docTitle__YSU0V"};